/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, getProp, CanBeSignals} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
// import {$SpinBtn, SpinBtnBaseProps} from './SpinBtn';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {$SpinBtn, SpinBtnProps} from './SpinBtn';

export const $SpinBtnUi: FC<SpinBtnProps> = (props) => {
    const responsive = Store.computed(() => {
        const jurisdictionZoneHeight = getProp(props.jurisdictionZoneHeight);
        const yOffsetPortrait = -(jurisdictionZoneHeight + 294)
        const yOffsetLandscape = -(jurisdictionZoneHeight + 498)

        return slotStore.stage_isPortrait.value ? {
            box: {x: '50%', y: '100%'},
            translate: { y: `${yOffsetPortrait}px`}
        } as ResponsiveConf : {
            box: {x: '100%', y: '100%'},
            translate: {x: '-172px', y: `${yOffsetLandscape}px`}
        } as ResponsiveConf;
    });

    return <$SpinBtn {...props} responsive={responsive}/>;
};